var Slide = /** @class */ (function () {
    function Slide(obj, id) {
        if (id) {
            this.id = id;
        }
        this.link = obj.link;
        this.position = obj.position;
        this.image_url = obj.image_url;
        this.mobile_image_url = obj.mobile_image_url;
        this.to_date = obj.to_date;
        this.to_date_hour = obj.to_date_hour;
        this.from_date = obj.from_date;
        this.from_date_hour = obj.from_date_hour;
        this.seo_name = obj.seo_name;
        this.video_idx = obj.video_idx;
        this.countdown = obj.countdown || false;
    }
    Object.defineProperty(Slide.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Slide.prototype, "Link", {
        get: function () {
            return this.link;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Slide.prototype, "Position", {
        get: function () {
            return this.position;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Slide.prototype, "ImageUrl", {
        get: function () {
            return this.image_url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Slide.prototype, "MobileImageUrl", {
        get: function () {
            return this.mobile_image_url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Slide.prototype, "ToDate", {
        get: function () {
            return this.to_date;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Slide.prototype, "ToDateHour", {
        get: function () {
            return this.to_date_hour;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Slide.prototype, "FromDate", {
        get: function () {
            return this.from_date;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Slide.prototype, "FromDateHour", {
        get: function () {
            return this.from_date_hour;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Slide.prototype, "SeoName", {
        get: function () {
            return this.seo_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Slide.prototype, "VideoIdx", {
        get: function () {
            return this.video_idx;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Slide.prototype, "start_date", {
        get: function () {
            if (!this.from_date && !this.from_date_hour) {
                return '';
            }
            var data = [this.from_date, this.from_date_hour ? this.from_date_hour + ":00" : undefined];
            return data.join(' ');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Slide.prototype, "stop_date", {
        get: function () {
            if (!this.to_date && !this.to_date_hour) {
                return '';
            }
            var data = [this.to_date, this.to_date_hour ? this.to_date_hour + ":00" : undefined];
            return data.join(' ');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Slide.prototype, "CountDown", {
        get: function () {
            return this.countdown;
        },
        enumerable: false,
        configurable: true
    });
    return Slide;
}());
export { Slide };
export function createSlide(obj, id) {
    return new Slide(obj, id);
}
export function createSlides(rawSlides) {
    var slides = [];
    var rawSlidesData = rawSlides.data;
    for (var _i = 0, rawSlidesData_1 = rawSlidesData; _i < rawSlidesData_1.length; _i++) {
        var rawSlide = rawSlidesData_1[_i];
        var slide = createSlide(rawSlide.attributes, rawSlide.id);
        slides.push(slide);
    }
    return slides;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/slide/slide.ts
// module id = 44
// module chunks = 0